(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedRouteDialogController', MedRouteDialogController);

    MedRouteDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'MedRoute', 'Medication'];

    function MedRouteDialogController ($timeout, $scope, $uibModalInstance, entity, MedRoute, Medication) {
        var vm = this;

        vm.medRoute = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medRoute.id !== null) {
                MedRoute.update(vm.medRoute, onSaveSuccess, onSaveError);
            } else {
                MedRoute.save(vm.medRoute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:medRouteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
